// @ts-nocheck
import React from 'react';
import { ApplyPluginsType } from '/home/gitlab-runner/builds/-t7MzySz/0/axinan/fe/agency-vn-web/node_modules/umi/node_modules/@umijs/runtime';
import * as umiExports from './umiExports';
import { plugin } from './plugin';

export function getRoutes() {
  const routes = [
  {
    "path": "/",
    "component": require('@/layouts/index.tsx').default,
    "routes": [
      {
        "path": "/auth",
        "exact": true,
        "component": require('@/pages/auth/index.tsx').default
      },
      {
        "path": "/customers",
        "exact": true,
        "component": require('@/pages/customers/index.tsx').default
      },
      {
        "path": "/customers/modal/addCustomerModal",
        "exact": true,
        "component": require('@/pages/customers/modal/addCustomerModal.tsx').default
      },
      {
        "path": "/customers/policies/detail",
        "exact": true,
        "component": require('@/pages/customers/policies/detail/index.tsx').default
      },
      {
        "path": "/customers/policies",
        "exact": true,
        "component": require('@/pages/customers/policies/index.tsx').default
      },
      {
        "path": "/download",
        "exact": true,
        "component": require('@/pages/download/index.tsx').default
      },
      {
        "path": "/earnings/cash-history",
        "exact": true,
        "component": require('@/pages/earnings/cash-history/index.tsx').default
      },
      {
        "path": "/earnings/cash-out",
        "exact": true,
        "component": require('@/pages/earnings/cash-out/index.tsx').default
      },
      {
        "path": "/earnings",
        "exact": true,
        "component": require('@/pages/earnings/index.tsx').default
      },
      {
        "path": "/grow/insurance-basics/:id",
        "exact": true,
        "component": require('@/pages/grow/insurance-basics/[id].tsx').default
      },
      {
        "path": "/home",
        "exact": true,
        "component": require('@/pages/home/index.tsx').default
      },
      {
        "path": "/home/:type/application",
        "exact": true,
        "component": require('@/pages/home/[type]/application/index.tsx').default
      },
      {
        "path": "/home/:type/application/useGetFormConfig",
        "exact": true,
        "component": require('@/pages/home/[type]/application/useGetFormConfig.tsx').default
      },
      {
        "path": "/home/:type/payment",
        "exact": true,
        "component": require('@/pages/home/[type]/payment/index.tsx').default
      },
      {
        "path": "/home/:type/product-list/hooks/useProductList",
        "exact": true,
        "component": require('@/pages/home/[type]/product-list/hooks/useProductList/index.tsx').default
      },
      {
        "path": "/home/:type/product-list",
        "exact": true,
        "component": require('@/pages/home/[type]/product-list/index.tsx').default
      },
      {
        "path": "/home/:type/product-list/:productId/hooks/useHandleQuoteBack",
        "exact": true,
        "component": require('@/pages/home/[type]/product-list/[productId]/hooks/useHandleQuoteBack.tsx').default
      },
      {
        "path": "/home/:type/product-list/:productId",
        "exact": true,
        "component": require('@/pages/home/[type]/product-list/[productId]/index.tsx').default
      },
      {
        "path": "/home/:type/quote/confirmation",
        "exact": true,
        "component": require('@/pages/home/[type]/quote/confirmation/index.tsx').default
      },
      {
        "path": "/home/:type/quote/hc-info",
        "exact": true,
        "component": require('@/pages/home/[type]/quote/hc-info/index.tsx').default
      },
      {
        "path": "/home/:type/quote/hooks/useQuoteSteps",
        "exact": true,
        "component": require('@/pages/home/[type]/quote/hooks/useQuoteSteps.tsx').default
      },
      {
        "path": "/home/:type/quote",
        "exact": true,
        "component": require('@/pages/home/[type]/quote/index.tsx').default
      },
      {
        "path": "/home/:type/quote/pa-info",
        "exact": true,
        "component": require('@/pages/home/[type]/quote/pa-info/index.tsx').default
      },
      {
        "path": "/home/:type/quote/product-pick",
        "exact": true,
        "component": require('@/pages/home/[type]/quote/product-pick/index.tsx').default
      },
      {
        "path": "/home/:type/quote/travel-info",
        "exact": true,
        "component": require('@/pages/home/[type]/quote/travel-info/index.tsx').default
      },
      {
        "path": "/home/:type/quote/vehicle-info/hooks/useVehicleOptions",
        "exact": true,
        "component": require('@/pages/home/[type]/quote/vehicle-info/hooks/useVehicleOptions.tsx').default
      },
      {
        "path": "/home/:type/quote/vehicle-info",
        "exact": true,
        "component": require('@/pages/home/[type]/quote/vehicle-info/index.tsx').default
      },
      {
        "path": "/home/:type/share",
        "exact": true,
        "component": require('@/pages/home/[type]/share/index.tsx').default
      },
      {
        "path": "/home/:type/single-quote",
        "exact": true,
        "component": require('@/pages/home/[type]/single-quote/index.tsx').default
      },
      {
        "path": "/",
        "exact": true,
        "component": require('@/pages/index.tsx').default
      },
      {
        "path": "/login/forget-password",
        "exact": true,
        "component": require('@/pages/login/forget-password/index.tsx').default
      },
      {
        "path": "/login",
        "exact": true,
        "component": require('@/pages/login/index.tsx').default
      },
      {
        "path": "/login/set-payment-password",
        "exact": true,
        "component": require('@/pages/login/set-payment-password/index.tsx').default
      },
      {
        "path": "/me/business-management/downline",
        "exact": true,
        "component": require('@/pages/me/business-management/downline.tsx').default
      },
      {
        "path": "/me/business-management",
        "exact": true,
        "component": require('@/pages/me/business-management/index.tsx').default
      },
      {
        "path": "/me/business-management/overview",
        "exact": true,
        "component": require('@/pages/me/business-management/overview.tsx').default
      },
      {
        "path": "/me/business-management/upline",
        "exact": true,
        "component": require('@/pages/me/business-management/upline.tsx').default
      },
      {
        "path": "/me/change-password",
        "exact": true,
        "component": require('@/pages/me/change-password/index.tsx').default
      },
      {
        "path": "/me/change-password/reset/:pay_pass",
        "exact": true,
        "component": require('@/pages/me/change-password/reset/[pay_pass].tsx').default
      },
      {
        "path": "/me/edit-profile",
        "exact": true,
        "component": require('@/pages/me/edit-profile/index.tsx').default
      },
      {
        "path": "/me/forget-password",
        "exact": true,
        "component": require('@/pages/me/forget-password/index.tsx').default
      },
      {
        "path": "/me/forget-payment-password",
        "exact": true,
        "component": require('@/pages/me/forget-payment-password/index.tsx').default
      },
      {
        "path": "/me/forget-payment-password/reset-payment-password",
        "exact": true,
        "component": require('@/pages/me/forget-payment-password/reset-payment-password/index.tsx').default
      },
      {
        "path": "/me",
        "exact": true,
        "component": require('@/pages/me/index.tsx').default
      },
      {
        "path": "/me/profile",
        "exact": true,
        "component": require('@/pages/me/profile/index.tsx').default
      },
      {
        "path": "/me/receiving-account",
        "exact": true,
        "component": require('@/pages/me/receiving-account/index.tsx').default
      },
      {
        "path": "/me/verify-payment-password/:type",
        "exact": true,
        "component": require('@/pages/me/verify-payment-password/[type].tsx').default
      },
      {
        "path": "/onboarding",
        "exact": true,
        "component": require('@/pages/onboarding/index.tsx').default
      },
      {
        "path": "/onboarding/otp",
        "exact": true,
        "component": require('@/pages/onboarding/otp/index.tsx').default
      },
      {
        "path": "/onboarding/success",
        "exact": true,
        "component": require('@/pages/onboarding/success/index.tsx').default
      },
      {
        "path": "/policies/detail",
        "exact": true,
        "component": require('@/pages/policies/detail/index.tsx').default
      },
      {
        "path": "/policies",
        "exact": true,
        "component": require('@/pages/policies/index.tsx').default
      }
    ]
  }
];

  // allow user to extend routes
  plugin.applyPlugins({
    key: 'patchRoutes',
    type: ApplyPluginsType.event,
    args: { routes },
  });

  return routes;
}
